import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "react-multi-email/dist/style.css";

// Redesign design system — MUST load AFTER bootstrap + vendor CSS so the
// --bs-* token overrides win. theme.css = tokens (light+dark), components.css =
// the .mca-* component kit. (Phase 0 of the dashboard redesign.)
import "./styles/theme.css";
import "./styles/components.css";
import "./styles/shell.css";
import "./styles/auth.css";

import { AppRoutes } from "./components/AppRoutes";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import { zipCodeReducer } from "./reducer/zipCode/ZipCode.reducer";
import { HeaderContextProvider } from "./contexts/HeaderContext";
import { collectionReducer } from "./reducer/collection/Collection.reducer";
import { planPaymentReducer } from "./reducer/payment/PlanPayment.reducer";
import { documentationReducer } from "./reducer/documentation/Documentation.reducer";
import { asinReducer } from "./reducer/asin/Asin.reducer";
import { downloadReducer } from "./reducer/download/Download.reducer";

export default function App() {
  // const [accountOpen, setAccountOpen] = useState(false);

  const location = useLocation();

  const isAuthRoute = [
    "/sign-in",
    "/sign-up",
    "/password/forgot",
    "/password/reset",
  ].includes(location.pathname);

  if (isAuthRoute) return <AppRoutes />;

  const rootReducer = combineReducers({
    zipCodeReducer: zipCodeReducer,
    collectionReducer: collectionReducer,
    planPaymentReducer: planPaymentReducer,
    documentationReducer: documentationReducer,
    asinReducer: asinReducer,
    downloadReducer: downloadReducer,
  });

  const myStore = configureStore({
    reducer: rootReducer,
  });

  if (isAuthRoute) return <AppRoutes />;

  return (
    <Provider store={myStore}>
      <HeaderContextProvider>
        <AppRoutes />
        <ToastContainer theme="dark" autoClose={1000} />
      </HeaderContextProvider>
    </Provider>
  );
}
